import { IInterestManagementData } from '@/app/interest-management/entities/interest-management-data.interface';
import { ConfigurationAbstract } from '@/common/configuration.abstract';
import { DOMUtil } from 'webshop-modules';
import { SubscriptionConfiguration, TranslationServiceConfiguration } from '../../../../../modules';
import { InterestConfiguration } from '../../../../../modules/resource/interest/interest-configuration.interface';
import { StorageConfiguration } from '../../../../../modules/storage/StorageConfiguration.interface';

export class ConfigurationProvider extends ConfigurationAbstract {

    private readonly applicationData: IInterestManagementData;

    constructor(
        private readonly scriptName: string
    ) {
        super();

        const scriptElement = DOMUtil.getInjectedConfigurationScript(document, this.scriptName) as HTMLScriptElement;
        this.applicationData = this.parseApplicationDataString(this.getDataAttributeFor('data-application', scriptElement));
    }

    private parseApplicationDataString(applicationDataString: string): IInterestManagementData {
        const initialParse = JSON.parse(applicationDataString);

        return {
            ...initialParse,
            user: initialParse.user ? JSON.parse(initialParse.user) : null,
            userEmail: initialParse.userEmail !== '' ? initialParse.userEmail : null,
        };
    }

    public getApplicationData(): IInterestManagementData {
        return this.applicationData;
    }

    public getResourceConfiguration(): InterestConfiguration {
        return {
            clientId: this.applicationData.poolId,
            userSubscriptionRootPath: this.applicationData.userSubscriptionRootPath,
        };
    }

    public getSubscriptionResourceConfiguration(): SubscriptionConfiguration {
        return {
            clientId: this.applicationData.poolId,
            endpoint: this.applicationData.userSubscriptionRootPath + 'subscribe.html',
        };
    }

    public getTranslationConfiguration(): TranslationServiceConfiguration {
        return {
            clientId: this.applicationData.poolId,
            staticUrl: this.applicationData.staticUrl,
        };
    }

    public getStorageConfiguration(): StorageConfiguration {
        return {
            poolId: this.applicationData.poolId
        }
    }

}
